import api from '@pray/shared/utils/api';

// DELETE …/campaigns/recurring-push/:id responds 204 No Content — no body to unwrap.
// The server blocks deletion while `active` or `done`; the UI only surfaces the
// affordance for `draft` / `stopped`, but the guard lives on the server.
export async function deleteRecurringPushCampaign({
  artistId,
  recurringCampaignId,
}: {
  artistId: string;
  recurringCampaignId: string;
}): Promise<void> {
  if (!artistId) throw new Error('Artist ID is required');
  if (!recurringCampaignId) throw new Error('Recurring campaign ID is required');

  const url = `/web/studio/artists/${artistId}/campaigns/recurring-push/${recurringCampaignId}`;
  await api.executeDeleteRequest<void>(url);
}
